import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Instagram, Facebook, Twitter, Youtube, Linkedin, Plug, Lock, Clock, CheckCircle2, MessageCircle } from "lucide-react";

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  twitter: Twitter,
  whatsapp: MessageCircle,
  youtube: Youtube,
  linkedin: Linkedin,
  tiktok: MessageCircle,
  snapchat: MessageCircle,
};

const STATUS_META = {
  available: { color: "bg-mint", label: "Available", icon: CheckCircle2 },
  coming_soon: { color: "bg-butter", label: "Coming Soon", icon: Clock },
  api_unavailable: { color: "bg-muted", label: "API Not Available", icon: Lock },
  api_restricted: { color: "bg-peach", label: "Restricted Access", icon: Lock },
};

export default function Platforms() {
  const [platforms, setPlatforms] = useState([]);

  useEffect(() => {
    api.get("/platforms").then((r) => setPlatforms(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="platforms-page">
      <header>
        <span className="chip bg-secondary">Platforms</span>
        <h1 className="text-4xl md:text-5xl font-extrabold mt-3">Supported channels</h1>
        <p className="text-muted-foreground font-medium mt-1 max-w-2xl">
          DmFlio's comment-to-DM engine works on any platform that exposes both a public comments webhook and a programmatic DM API. Here's the honest matrix.
        </p>
      </header>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {platforms.map((p) => {
          const Icon = ICONS[p.id] || Plug;
          const meta = STATUS_META[p.status] || STATUS_META.coming_soon;
          const StatusIcon = meta.icon;
          return (
            <div key={p.id} className={`brutal p-5 ${p.status === "available" ? "bg-white" : "bg-card"}`} data-testid={`platform-${p.id}`}>
              <div className="flex items-start justify-between mb-3">
                <div className="w-11 h-11 bg-secondary border-2 border-foreground rounded-md shadow-brutal-sm flex items-center justify-center">
                  <Icon className="w-5 h-5" strokeWidth={2.5} />
                </div>
                <span className={`chip ${meta.color} flex items-center gap-1`}>
                  <StatusIcon className="w-3 h-3" strokeWidth={3} /> {meta.label}
                </span>
              </div>
              <h3 className="font-heading font-extrabold text-lg">{p.name}</h3>
              <p className="text-sm font-medium text-muted-foreground mt-1 leading-relaxed">{p.note}</p>
            </div>
          );
        })}
      </div>

      <div className="brutal p-5 bg-secondary text-sm font-medium leading-relaxed">
        <strong className="font-extrabold">Why some platforms aren't supported:</strong> YouTube, TikTok, and Snapchat don't expose a public DM API at all. LinkedIn DM is restricted to LinkedIn Marketing Partners. X (Twitter) requires a paid API tier ($200+/mo). We'll add Coming Soon channels as their APIs become accessible.
      </div>
    </div>
  );
}
